import type { FunctionComponent } from "react";

import { config } from "shared/data/configs";

import { useUserService } from "scmp-app/lib/user-service/hooks";

import { BookmarkItems } from "./bookmark-items";
import {
  Container,
  EmptyBookmark,
  ManageButton,
  StyledBookmarksIconSvg,
  Title,
  TitleContainer,
} from "./styles";

export type Props = {
  className?: string;
};

export const MyBookmarks: FunctionComponent<Props> = ({ className }) => {
  const { bookmarks } = useUserService();

  return (
    <Container className={className}>
      <TitleContainer>
        <StyledBookmarksIconSvg />
        <Title>My Bookmarks</Title>
        <ManageButton href={`${config.account.scmpAccountHost}/manage/bookmark`} target="_blank">
          MANAGE
        </ManageButton>
      </TitleContainer>
      {!bookmarks || bookmarks.length === 0 ? (
        <EmptyBookmark>Your bookmark(s) will be shown here.</EmptyBookmark>
      ) : (
        <BookmarkItems bookmarks={bookmarks} />
      )}
    </Container>
  );
};

MyBookmarks.displayName = "MyBookmarks";
